import { hrmService } from '@/services/hrmService'

const state = {
  previousEmploymentInfoList: [],
  currentPreviousEmploymentInfo: null,
  loading: false,
  error: null
}

const getters = {
  getPreviousEmploymentInfoList: (state) => state.previousEmploymentInfoList,
  getCurrentPreviousEmploymentInfo: (state) => state.currentPreviousEmploymentInfo,
  isLoading: (state) => state.loading,
  getError: (state) => state.error
}

const actions = {
  async fetchPreviousEmploymentInfoByEmployee({ commit }, employeeId) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await hrmService.getPreviousEmploymentInfoByEmployee(employeeId)
      if (response.success) {
        commit('SET_PREVIOUS_EMPLOYMENT_INFO_LIST', response.data)
      } else {
        commit('SET_ERROR', response.message)
      }
    } catch (error) {
      commit('SET_ERROR', error.message)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async saveEmployeePreviousEmploymentInfo({ commit }, { employeeId, employmentData }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await hrmService.saveEmployeePreviousEmploymentInfo(employeeId, employmentData)
      if (response.success) {
        commit('SET_PREVIOUS_EMPLOYMENT_INFO_LIST', response.data)
        return response
      } else {
        commit('SET_ERROR', response.message)
        throw new Error(response.message)
      }
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchPreviousEmploymentInfoById({ commit }, id) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await hrmService.getPreviousEmploymentInfoById(id)
      if (response.success) {
        commit('SET_CURRENT_PREVIOUS_EMPLOYMENT_INFO', response.data)
      } else {
        commit('SET_ERROR', response.message)
      }
    } catch (error) {
      commit('SET_ERROR', error.message)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async savePreviousEmploymentInfo({ commit }, employmentData) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await hrmService.savePreviousEmploymentInfo(employmentData)
      if (response.success) {
        commit('SET_CURRENT_PREVIOUS_EMPLOYMENT_INFO', response.data)
        return response
      } else {
        commit('SET_ERROR', response.message)
        throw new Error(response.message)
      }
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updatePreviousEmploymentInfo({ commit }, { id, employmentData }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await hrmService.updatePreviousEmploymentInfo(id, employmentData)
      if (response.success) {
        commit('SET_CURRENT_PREVIOUS_EMPLOYMENT_INFO', response.data)
        return response
      } else {
        commit('SET_ERROR', response.message)
        throw new Error(response.message)
      }
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deletePreviousEmploymentInfo({ commit }, id) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await hrmService.deletePreviousEmploymentInfo(id)
      if (response.success) {
        return response
      } else {
        commit('SET_ERROR', response.message)
        throw new Error(response.message)
      }
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  clearError({ commit }) {
    commit('SET_ERROR', null)
  },

  clearCurrentPreviousEmploymentInfo({ commit }) {
    commit('SET_CURRENT_PREVIOUS_EMPLOYMENT_INFO', null)
  }
}

const mutations = {
  SET_PREVIOUS_EMPLOYMENT_INFO_LIST(state, list) {
    state.previousEmploymentInfoList = list
  },
  SET_CURRENT_PREVIOUS_EMPLOYMENT_INFO(state, info) {
    state.currentPreviousEmploymentInfo = info
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
